import { IconChevronRight16 } from '@cian/ui-kit/icons';
import { UIText1 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './CellLinksItem.css';

interface ICellLinksItemProps {
  icon: React.ReactElement;
  text: string;
  href: string;
  onClick?(): void;
}

export const CellLinksItem: React.FC<ICellLinksItemProps> = ({ icon, text, href, onClick }) => {
  const handleClick = React.useCallback(() => {
    if (onClick) {
      onClick();
    }
  }, [onClick]);

  return (
    <li className={styles['list-item']}>
      <a href={href} className={styles['content']} onClick={handleClick} target="_blank" rel="noreferrer">
        <span className={styles['icon']}>{icon}</span>
        <span className={styles['right-block']}>
          <span className={styles['text']}>
            <UIText1>{text}</UIText1>
          </span>
          <IconChevronRight16 color="gray40_100" />
        </span>
      </a>
    </li>
  );
};
